export default __webpack_public_path__ + "static/favicon-5b6d34b6148e2c12c77a485c45b27fb0.png";